import { PlusIcon } from "@heroicons/react/24/solid";
import { Link } from "react-router-dom";

interface NavigationItemProps {
  to: string;
  icon: React.ReactNode;
  label: string;
  isCollapsed: boolean;
  isActive: boolean;
}

export default function NavigationItem({
  to,
  icon,
  label,
  isCollapsed,
  isActive,
  showPlusIcon = false,
}: NavigationItemProps & { showPlusIcon?: boolean }) {
  return (
    <Link
      to={to}
      className={`flex items-center px-3 py-2.5 rounded-md transition-all duration-200 relative ${
        isActive
          ? "bg-blue-50 dark:bg-blue-900/20 text-blue-500 dark:text-blue-400 font-bold"
          : "text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800"
      } ${isCollapsed ? "justify-center" : ""}`}
    >
      {/* Active indicator line */}
      {/* {isActive && (
        <div className="absolute left-0 top-0 bottom-0 w-1 bg-blue-600 rounded-r"></div>
      )} */}
      <div
        className={`transition-colors duration-200 ${
          isActive
            ? "text-blue-500 fill-blue-500 dark:text-blue-400 dark:fill-blue-400 font-semibold"
            : "text-gray-400 fill-gray-400 dark:text-gray-400"
        }`}
      >
        {icon}
      </div>
      {!isCollapsed && (
        <span className="ml-4 flex-grow transition-colors duration-200">
          {label}
        </span>
      )}
      {showPlusIcon && !isCollapsed && (
        <div className="ml-auto">
          <div className="flex items-center justify-center w-6 h-6 dark:bg-gray-800 rounded-full border border-blue-300 dark:border-blue-400">
            <PlusIcon className="w-3 h-3 text-blue-500 dark:text-blue-400" />
          </div>
        </div>
      )}
      {showPlusIcon && isCollapsed && (
        <div className="absolute right-2 top-2">
          <div className="flex items-center justify-center w-5 h-5 dark:bg-gray-800 rounded-full border border-blue-500 dark:border-blue-400">
            <PlusIcon className="w-3.5 h-3.5 text-blue-500 dark:text-blue-400" />
          </div>
        </div>
      )}
    </Link>
  );
}
